import { FC } from 'react';
import styles from './sidebar-toggle.module.css';

export const SidebarToggle: FC<{ onClick: () => void; expanded: boolean }> = ({
  onClick,
  expanded,
}) => {
  return (
    <span onClick={onClick} className={styles.sidebar__toggle}>
      <i
        className={`pi pi-chevron-right ${
          expanded ? styles.open : styles.close
        }`}
      ></i>
    </span>
  );
};
